import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminAuthProvider, useAdminAuth } from '../../context/AdminAuthContext';
import AdminLayout from '../../components/admin/AdminLayout';
import Dashboard from './Dashboard';
import BarberDashboard from './BarberDashboard';
import ClientGallery from './ClientGallery';
import GeneratedHairstylesGallery from './GeneratedHairstylesGallery';
import HairstyleSuggestions from './HairstyleSuggestions';
import BarberSuggestions from './BarberSuggestions';
import Bookings from './BookingsNew';
import Clients from './Clients';
import Barbers from './Barbers';
import Services from './Services';
import Availability from './Availability';
import Settings from './Settings';
import Profile from './Profile';
import ClientAIAnalysisForClientPage from './ClientAIAnalysisForClientPage';
import EnhancedAIHairstyleAnalysis from './EnhancedAIHairstyleAnalysis';
import Notifications from './Notifications';
import QRGenerator from './QRGenerator';
import InventoryDashboard from './Inventory/InventoryDashboard';
import Products from './Inventory/Products';
import ProductDetail from './Inventory/ProductDetail';
import AddProduct from './Inventory/AddProduct';
import EditProduct from './Inventory/EditProduct';
import Suppliers from './Inventory/Suppliers';
import InventorySettings from './Inventory/InventorySettings';
import ContactSupport from './ContactSupport';
import MakeupStudio from './MakeupStudio';
// import BotoxFillerStudio from './BotoxFillerStudio'; // HIDDEN: Botox & Filler feature disabled
import HaircutsStudio from './HaircutsStudio';
import NailsStudio from './NailsStudio';
import Credits from './Credits';

const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
  </div>
);

const AdminContent = () => {
  const { user, loading, error, hasAdminAccess } = useAdminAuth();

  // Show loading spinner while fetching user data
  if (loading) {
    return <LoadingSpinner />;
  }

  // Redirect to homepage with sign-in panel if not authenticated or no admin access
  if (error || !user || !hasAdminAccess()) {
    return <Navigate to="/?auth=1" replace />;
  }

  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={user?.role === 'barber' ? <BarberDashboard /> : <Dashboard />} />
        <Route path="/client-gallery" element={<ClientGallery />} />
        <Route path="/generated-hairstyles" element={<GeneratedHairstylesGallery />} />
        <Route path="/suggestions" element={user?.role === 'barber' ? <BarberSuggestions /> : <HairstyleSuggestions />} />
        <Route path="/bookings" element={<Bookings />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/:clientId/ai-analysis" element={<ClientAIAnalysisForClientPage />} />
        <Route path="/barbers" element={<Barbers />} />
        <Route path="/services" element={<Services />} />
        <Route path="/availability" element={<Availability />} />
        <Route path="/ai-analysis" element={<EnhancedAIHairstyleAnalysis />} />
        <Route path="/makeup-studio" element={<MakeupStudio />} />
        {/* <Route path="/botox-filler-studio" element={<BotoxFillerStudio />} /> */}{/* HIDDEN: Botox & Filler feature disabled */}
        <Route path="/haircuts-studio" element={<HaircutsStudio />} />
        <Route path="/nails-studio" element={<NailsStudio />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/qr" element={<QRGenerator />} />
        <Route path="/inventory" element={<InventoryDashboard />} />
        <Route path="/inventory/products" element={<Products />} />
        <Route path="/inventory/products/:id" element={<ProductDetail />} />
        <Route path="/inventory/products/add" element={<AddProduct />} />
        <Route path="/inventory/products/:id/edit" element={<EditProduct />} />
        <Route path="/inventory/suppliers" element={<Suppliers />} />
        <Route path="/inventory/settings" element={<InventorySettings />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/contact" element={<ContactSupport />} />
        <Route path="/credits" element={<Credits />} />
      </Routes>
    </AdminLayout>
  );
};

const AdminWrapper = () => {
  return (
    <AdminAuthProvider>
      <AdminContent />
    </AdminAuthProvider>
  );
};

export default AdminWrapper;
